/* 
* @Description: 描述
* @Author: D
* @Date: 2024-04-09 14:16
* @LastEditTime: 2024-04-12 09:07
* @LastEditors: D
* @FilePath: \web\src\api\auctionVehicles\index.js
*/
import request from '@/utils/request'

// 拍卖车辆 -- 列表
export function getAuctionInfoList(params) {
    return request({
        url: '/front/auction/nlr/getAuctionInfoAndCarListPage',
        method: 'GET',
        params
    })
}
// 拍卖车辆 -- 详情
export function findAuctionCarInfo(params) {
    return request({
        url: '/front/auction/nlr/findAuctionCarInfo',
        method: 'GET',
        params
    })
}
//拍卖出价
export function auctionBid(data) {
    return request({
        url: '/front/auction/auctionBid',
        method: 'POST',
        data
    })
}

/**
 * 期车报价
 * @param {} data 
 * @returns 
 */
export function quotationsBid(data) {
    return request({
        url: '/front/quotations/bid',
        method: 'POST',
        data
    })
}



//查询拍卖车辆
export function findSysConfigAuctionCar(data) {
    return request({
        url: '/front/sysconfig/findSysConfigAuctionCar',
        method: 'POST',
        data
    })
}

//关注
export function frontUserFollow(data) {
    return request({
        url: '/front/userFollow/concern',
        method: 'POST',
        data
    })
}


//取消关注
export function frontuserFollowClose(data) {
    return request({
        url: '/front/userFollow/close',
        method: 'POST',
        data
    })
}
